import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../utils/breadCrumbs";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  ContainerBB,
  TitleBB,
  TitleJunction,
  ButtonRemove,
} from "./inventaryDetail.styled";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import moment from "moment-timezone";

const InventaryDetailView = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, finish, onSave, exportToExcel } = props;

  let sumIn = 0;

  if (data) {
    if (data.inventarys && data.inventarys.length > 0) {
      for (const dataIn of data.inventarys) {
        sumIn += dataIn.weight;
      }
    }
  }

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.inventary.titleProcess"), path: PATHS.INVENTARY_LIST },
    { label: t("forms.inventary.title") },
  ];

  const renderBB = (bbs, isInput = true) => {
    if (bbs && bbs.length > 0) {
      return bbs.map((bb) => {
        return (
          <div className="row mb-1" key={bb.batch}>
            <div className="col-2">{bb.batch}</div>
            <div className="col-5 text-center">{`${bb.descriptionArticle} (${bb.numArticle})`}</div>
            <div className="col-1 text-end">{`${bb.weight}Kg`}</div>
            <div className="col-2 text-end">
              {moment(bb.date).format("DD-MM-yyyy HH:mm")}
            </div>
            <div className="col-2 text-end">
              {bb.existingStock ? "En existencias" : "No hay Stock"}
            </div>
            {/* <div className="col-2 text-end">
              {isInput && (
                <ButtonRemove type="button" onClick={() => removeItem(bb)}>
                  <i className="fa-solid fa-trash-can"></i>
                </ButtonRemove>
              )}
            </div> */}
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">{t("forms.inventary.noBb")}</div>
        </div>
      );
    }
  };
  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.inventary.title`)}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />

      {data && (
        <>
          <div className="row justify-content-center  mt-4">
            <TitleJunction className="col-12 col-md-11 ">
              <div className="d-flex">
                {data?.status === "OPEN"
                  ? `${t(
                      "forms.inventary.processOpen"
                    )} (${getDateFormatTimeZone(data.dateInit, "DD-MM-yyyy")})`
                  : `${t(
                      "forms.inventary.processClosed"
                    )} (${getDateFormatTimeZone(data.dateEnd, "DD-MM-yyyy")})`}
              </div>
            </TitleJunction>
            <div className="d-flex col-12 col-md-11 mt-3 mb-3 gap-2">
              {data.status === "OPEN" && (
                <>
                  <button
                    type="button"
                    className="btn btn-mg btn-secondary"
                    onClick={onSave}
                  >
                    {t("forms.inventary.buttons.save")}
                  </button>
                </>
              )}

              <button
                type="button"
                className="btn btn-md btn-primary"
                onClick={() => exportToExcel()}
              >
                {t("exportFileExcel")}
              </button>
              {data.status === "OPEN" && (
                <button
                  type="button"
                  className="btn btn-md btn-secondary"
                  onClick={() => finish()}
                >
                  {t("forms.inventary.buttons.finish")}
                </button>
              )}
            </div>
          </div>
          <div className="row justify-content-center mt-2 mb-4">
            <div className="col-12 col-md-11">
              <div className="row">
                <TitleBB className="col-12 d-flex justify-content-between">
                  <div>{t("forms.inventary.bbIn")}</div>
                  <div>{`Total: ${sumIn}Kg`}</div>
                </TitleBB>
              </div>
              <div className="row">
                <div className="col-12 mb-5">
                  <ContainerBB>{renderBB(data.inventarys)}</ContainerBB>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11 text-center"></div>
      </div> */}
    </>
  );
};

InventaryDetailView.propTypes = {
  // handleSubmit: PropTypes.func,
  // initialValues: PropTypes.object,
};

export default InventaryDetailView;
